import React from 'react'
import styled from 'styled-components'

import { FieldWrapperProps } from './FieldWrapper.types'
import { styleTheme } from '../../../../style/theme'
import { RequiredIcon } from '../../../../icons/requiredMark'

export const FieldWrapper: React.FC<FieldWrapperProps> = (props) => {
  return <StyledComponent {...props} />
}

type ComponentProps = FieldWrapperProps & {
  className?: string
}

const Component: React.FC<ComponentProps> = (props) => (
  <div className={`${props.className} wrapper`}>
    {props.label && (
      <div className={`${props.className} label-wrapper`} data-column={!!props.column}>
        <div data-error={!!props.error} className={`${props.labelClassName || ''} ${props.className} label`}>
          <div className="label-text">{props.label}</div>
          {props.isRequired && <RequiredIcon />}
        </div>
      </div>
    )}
    <div className={`${props.className} field-wrapper`} data-column={!!props.column}>
      <div className={`${props.fieldClassName || ''} ${props.className} field`}>{props.children}</div>
      {props.error?.message && (
        <div aria-label={props.error.message} className={`${props.className} error`}>
          {props.error.message}
        </div>
      )}
    </div>
  </div>
)

const StyledComponent = styled(Component)`
  &.wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }

  &.label-wrapper {
    max-width: 100%;
    min-width: 200px;
    width: calc((720px - 100%) * 720);
    display: flex;
    gap: 12px;
    justify-content: start;
    height: fit-content;
    padding-top: 8px;

    &[data-column='true'] {
      width: 100%;
      padding-top: 0;
    }
  }

  &.label {
    display: flex;
    gap: 8px;
    color: ${styleTheme.colors.black};
    font-size: 14px;
    font-weight: bold;
    align-items: center;

    > .label-text {
      max-width: 148px;
    }

    &[data-error='true'] {
      color: ${styleTheme.colors.pink.base};
    }
  }

  &.field-wrapper {
    max-width: 100%;
    min-width: calc(100% - 204px);
    width: calc((720px - 100%) * 720);

    &[data-column='true'] {
      width: 100%;
    }
  }

  &.field {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &.error {
    color: ${styleTheme.colors.pink.base};
    font-size: 16px;
  }
`
